import type { Metadata } from "next";
import { AuthorsHubView } from "@/components/authors/authors-hub-view";
import { site } from "@/content/site";

export const metadata: Metadata = {
  title: "Authors & Editorial Team",
  description:
    "Meet the builders, product engineers, and speech AI architects writing research, engineering guides, and product updates at Quto AI.",
  keywords: [
    "quto ai authors",
    "voice ai engineering team",
    "speech ai researchers",
    "quto founders",
  ],
  openGraph: {
    title: "Authors & Editorial Team",
    description:
      "Meet the engineers, product architects, and leaders building the future of enterprise voice AI.",
    url: `${site.url}/author`,
    siteName: site.name,
    locale: "en_US",
    type: "website",
  },
  alternates: {
    canonical: "/author",
  },
};

export default function AuthorsPage() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: "Quto AI Authors",
    description: "Meet the product architects and engineers building enterprise voice AI.",
    url: `${site.url}/author`,
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <AuthorsHubView />
    </>
  );
}
